export const INIT_CURRENT_RUBRIC = 'INIT_CURRENT_RUBRIC'
export const SET_CURRENT_FORMAT = 'SET_CURRENT_FORMAT'
